var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	89575: {
		fallback: () => (() => (__webpack_require__(9368))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.3.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@bcc-ui/ui-components",

	},
	53933: {
		fallback: () => (() => (__webpack_require__(65783))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^25.0.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "i18next",

	},
	94499: {
		fallback: () => (() => (__webpack_require__(22483))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.3.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	9041: {
		fallback: () => (() => (__webpack_require__(55139))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^15.4.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-i18next",

	},
	79357: {
		fallback: () => (() => (__webpack_require__(77810))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.3.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [89575,53933,94499,9041,79357];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"792": [
		89575,
		53933,
		94499,
		9041,
		79357
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}